import { Component, inject } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { RegisterModal } from '../register-modal/register-modal';
import { RegisterPromptModalComponent } from '../../modal/register-prompt-modal.component';
import { UniconRegisterModalComponent } from '../unicon-register-modal/unicon-register-modal.component';
import { ButtonComponent } from '@atoms/button/button.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { SvgIcon } from '@services/svg-icon.service';

@Component({
  selector: "app-hero-section",
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss'],
  standalone: true,
  imports: [CommonModule, RegisterPromptModalComponent, UniconRegisterModalComponent, ButtonComponent, SvgIconComponent],
})
export class HeroSectionComponent {
  protected readonly SvgIcon = SvgIcon;
  showRegisterPromptModal = false;
  showUniconRegisterModal = false;

  private readonly bottomSheet = inject(MatBottomSheet);

  openRegisterPromptModal(): void {
    this.bottomSheet.open(RegisterModal, {
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'register-modal-bottom-sheet',
    });
  }
  
  closeRegisterPromptModal() { 
    this.showRegisterPromptModal = false; 
  }

  // Métodos para el modal de registro de UNICON
  openUniconRegisterModal() { 
    this.showUniconRegisterModal = true; 
  }
  
  closeUniconRegisterModal() { 
    this.showUniconRegisterModal = false; 
  }
}
